var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 597,
    height: 880,
    viewBox: "0 0 597 880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "15.404%",
    x2: "74.505%",
    y1: "166.891%",
    y2: "-10.033%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#C9C1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "57%",
    stopColor: "#DED9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "-91.502%",
    x2: "135.93%",
    y1: "165.013%",
    y2: "-22.254%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13%",
    stopColor: "#CAC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M530.75 383.905c42.573 89.979 37.63 247.08-4.553 349.063a48.296 48.296 0 0 1-4.452 8.359c-40.762 61.257-153.62 183.517-376.811 121.582a49.274 49.274 0 0 1-4.926-1.696c-19.4-7.51-81.135-35.69-105.595-65.106a41.721 41.721 0 0 1-2.743-3.696C1.573 747.278-8.177 700.721 7.312 659.537c18.84-50.186 47.617-94.946 75.785-139.655 7.11-11.241 7.685-22.584 12.814-35.046 7.787-18.87 9.141-39.843 8.464-60.511-.677-23.16-4.164-46.15-13.322-67.022-7.922-18.074-12.239-34.554-19.095-53.136-11.697-31.756-10.833-67.446-5.738-101.236 6.636-43.845 20.449-87.08 45.01-122.447 23.937-34.418 58.74-60.817 97.437-68.107 2.319-.424 4.638-.865 6.923-1.407 1.49-.356 3.03-.424 4.537-.679C281.862.254 381.65-10.054 430.86 19.193c43.809 26.042 78.087 42.556 93.34 96.302 3.385 11.7 4.062 58.528-1.592 69.345-12.306 23.482-34.397 109.07 8.142 199.065z",
    opacity: 0.7,
    transform: "translate(36)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FD",
    d: "M493.966 477.53v306.852c0 22.433-18.204 40.618-40.66 40.618H214.66C192.204 825 174 806.815 174 784.382V175.618C174 153.185 192.204 135 214.66 135h238.68c22.456 0 40.66 18.185 40.66 40.618V477.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4738A7",
    d: "M434 836l-52.689-72.542S351.653 722.706 333.02 722c-.152 10.675.575 87.42 3.872 113.933H434V836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M263.44 114h139.12a11.33 11.33 0 0 1 8.1 3.385 11.636 11.636 0 0 1 3.34 8.207v17.816a11.636 11.636 0 0 1-3.34 8.207 11.33 11.33 0 0 1-8.1 3.385H263.44a11.33 11.33 0 0 1-8.1-3.385 11.636 11.636 0 0 1-3.34-8.207v-17.816c.019-6.394 5.13-11.573 11.44-11.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5648B6",
    d: "M486.14 827.18H496V709.515L412.86 696 348 725.157c3.697 8.249 9.586 62.941 51.439 110.843h86.633v-8.82h.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD45C",
    d: "M494 476.063C479.868 452.934 459.153 438 429.45 438c-103.069 0-106.014 271.144-95.25 286.233 9.529 13.343 123.226 16.816 159.8 7.612"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD3FD",
    d: "M448.076 465.152s-23.554 88.713-28.605 112.147c-5.051 23.434-6.718 158.964 10.102 162.383 20.187 3.419 53.123 3.419 64.41-2.461 11.288-5.88 0-112.814 0-112.814l-10.016-38.767 10.016-111.48S474.26 443.684 448.558 441c-.482 12.41-.482 24.152-.482 24.152zM401.53 461.39s-9.847 61.243 0 105.925c9.848 44.682 3.817 133.615 1.675 150.607-2.142 16.992 3.436 22.913-24.448 20.597-23.028.66-39.51-7.365-44.434-13.99-8.207-4.968-62.653-276.693 66.856-280.529.351 15.7.351 17.39.351 17.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M501 557.72c-14.599-5.44-21.586-7-20.962-4.68.937 3.48 0 51.245 15.403 92.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M510.053 477.941c-6.437-5.098-13.21-7.453-19.754-5.455-37.668 11.548-17.566 98.21-7.163 102.062 3.31 1.234 11.099.774 20.192-.788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M449 459.043c0 8.305-46 10.199-46 0V402h46v57.043z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.22,
    cy: 378.757,
    fill: "#F7BDAD",
    rx: 57.709,
    ry: 42.952,
    transform: "rotate(-68.3 419.22 378.757)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 456.243,
    cy: 398.928,
    fill: "#F7BDAD",
    rx: 13.588,
    ry: 9.487,
    transform: "rotate(-54.39 456.243 398.928)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M496 372.185c0-7.788-7.45-16.362-8.834-26.14-.718-5.014.871-25.572-5.126-32.576-12.303-14.457-19.548-11.482-28.963-14.875-16.37-5.883-22.675-15.594-36.208-15.594-15.379 0-21.582 7.789-32.586 7.789-12.61 0-22.88-5.666-40.565-5.666-9.415 0-21.718 12.05-21.718 22.68 0 25.071 23.922 21.528 23.922 27.612 0 4.262-1.452 7.655-1.452 13.471 0 7.639 10.133 12.034 15.925 12.034 17.668 0 19.992-2.122 19.992-2.122a77.844 77.844 0 0 1 13.328-18.77c.718-.702 12.167 7.153 30.843 7.789 15.379.501 26.144 3.342 26.144 10.412 0 5.015-1.88 19.623-1.71 23.734.172 4.112 1.607 6.803 2.547 6.803.94 0 1.452-1.354 7.382-1.354 6.305 0 6.834 7.588 7.894 7.588 6.305 0 29.185-5.03 29.185-22.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    fillRule: "nonzero",
    d: "M455.167 109H213.833c-32.489.01-58.824 26.321-58.833 58.782v616.436c.01 32.46 26.344 58.773 58.833 58.782h241.334c32.489-.01 58.824-26.321 58.833-58.782V167.782c-.01-32.46-26.344-58.773-58.833-58.782zm39.358 364.612v307.05c0 22.447-18.214 40.644-40.68 40.644H215.054c-22.467 0-40.68-18.197-40.68-40.644V171.507c0-22.447 18.213-40.644 40.68-40.644h238.79c22.467 0 40.68 18.197 40.68 40.644v302.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M252.756 288h-86.462c-15.619.02-28.275 13.44-28.294 30 .019 16.56 12.675 29.98 28.294 30h86.429c15.616-.02 28.268-13.442 28.277-30 .01-16.552-12.633-29.98-28.244-30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M259 334.45l7.58-33.45L293 342z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 319,
    r: 8,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 319,
    r: 8,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 319,
    r: 8,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M402.948 441h-7.282l-15.881 20.814 11.774 14.091L379 485.863S399.826 553.401 405 589c0 0-9.533-74.108-2.052-127.355-.416-18.934 0-20.645 0-20.645zM456.842 441.244L467 474.474l-14.505 8.381 9.665 10.077L421 576l1.646-10.06s11.295-45.313 26.606-104.901c0-26.856-.346-21.629-.346-21.629l7.936 1.834z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.215,
    cy: 746.229,
    fill: "#FBB5A9",
    rx: 17.592,
    ry: 24.737,
    transform: "rotate(-6.52 318.215 746.23)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M310.451 542c-2.486 5.063-19.403 61.907-17.265 110.852 2.139 48.945 10.05 76.674 9.963 80.522-.087 3.849 28.792 2.937 28.844.642.052-2.296-5.737-72-3.842-84.388 1.895-12.388 25.193-83.29 24.845-92.084-.348-8.793-42.545-15.544-42.545-15.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M359.013 463.056c-26.911-10.314-60.645 58.046-57.85 70.078 3.472 15.177 41.026 32.435 60.09 29.547 8.993-1.358 19.844-91.134-2.24-99.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M450 542h7v23h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M442 557v-7h23v7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M73.371 9.007C62.914-1.405 44.486-.017 32.47 8.584c-12.018 8.6-18.858 22.5-24 36.264C2.503 60.898-1.817 78.252 1.61 95.03c3.429 16.778 16.046 32.658 33.155 35.333 15.84 2.388 31.663-7.043 40.988-19.91 9.326-12.867 13.389-28.764 16.68-44.255 3.086-14.442 5.623-29.798.6-43.68C88.011 8.633 72.754-2.76 58.457 1.49",
    opacity: 0.75,
    transform: "translate(0 368)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.5,
    cy: 769.5,
    r: 37.5,
    fill: "#D7C7FD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M304.099 779h15.35l-1.792-7.633a17.991 17.991 0 0 1 11.869-3.817c7.817 0 0-9.55 0-9.55s-27.37.051-25.427 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M353.898 779H338.58l1.795-7.633a18.057 18.057 0 0 0-11.894-3.817c-7.834 0 0-9.55 0-9.55s27.395.051 25.416 21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero1);
export default __webpack_public_path__ + "static/media/hero-1.c1b3dd8b667164b4d4cfd32e678722e7.svg";
export { ForwardRef as ReactComponent };